import { CommonModule } from '@angular/common'
import { formatDate } from '@angular/common'
import { Component, effect, inject } from '@angular/core'
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'

import { Store } from '@ngrx/store'
import moment from 'moment'
import { DialogModule } from 'primeng/dialog'
import { ImageModule } from 'primeng/image'
import { ProgressBarModule } from 'primeng/progressbar'
import { TooltipModule } from 'primeng/tooltip'

import { AiActions, KeyboardActions } from '@flowx/designer/modules/new-ai/store/ai.actions'
import { AiSelectors } from '@flowx/designer/modules/new-ai/store/ai.selectors'

@Component({
  selector: 'flx-ai-agent-header',
  imports: [CommonModule, DialogModule, ImageModule, ProgressBarModule, TooltipModule],
  templateUrl: './agent-header.component.html',
  styleUrls: ['./agent-header.component.scss'],
  standalone: true,
})
export class AgentHeaderComponent {
  #store = inject(Store)

  logs = this.#store.selectSignal(AiSelectors.logs)
  isPlanSidebarVisible = this.#store.selectSignal(AiSelectors.isPlanSidebarVisible)
  isPlanEnabled = this.#store.selectSignal(AiSelectors.isPlanEnabled)
  isChatSidebarVisible = this.#store.selectSignal(AiSelectors.isChatSidebarVisible)
  isDocumentsSidebarVisible = this.#store.selectSignal(AiSelectors.isDocumentsSidebarVisible)
  currentContextDocument = this.#store.selectSignal(AiSelectors.selectedDocument)
  streamingAiResponse = this.#store.selectSignal(AiSelectors.streamingAiResponse)
  hasBusinessProcess = this.#store.selectSignal(AiSelectors.hasBusinessProcess)
  viewPlanSidebar(): void {
    this.#store.dispatch(AiActions.setPlanSidebarVisible({ isPlanSidebarVisible: true }))
  }

  viewChatSidebar(): void {
    this.#store.dispatch(AiActions.setChatSidebarVisible({ isChatSidebarVisible: true }))
  }

  viewDocumentsSidebar(): void {
    this.#store.dispatch(AiActions.setDocumentsSidebarVisible({ isDocumentsSidebarVisible: true }))
  }

  viewArchivedSidebar(): void {
    this.#store.dispatch(AiActions.setArchivedSidebarVisible({ isArchivedSidebarVisible: true }))
  }

  toggleZenMode(): void {
    this.#store.dispatch(KeyboardActions.toggleZenMode())
  }

  startNewSession(): void {
    this.#store.dispatch(AiActions.startNewSession())
  }

  updateElapsedTime(timestamp: string): string {
    const now = moment()
    const pastTime = moment(timestamp)

    // Example: Display exact time difference in years, months, days, hours, and minutes
    return `${pastTime.fromNow(true)} (${now.diff(pastTime, 'minutes') % 60} minutes, ${now.diff(pastTime, 'seconds') % 60} seconds ago)`
  }

  automateProcess(): void {
    this.#store.dispatch(AiActions.automateProcess())
  }
}
